export const getSafeLocalStorage = () => {
  try {
    if (typeof window === 'undefined') return null;
    const testKey = '__test__';
    window.localStorage.setItem(testKey, '1');
    window.localStorage.removeItem(testKey);
    return window.localStorage;
  } catch {
    return null;
  }
};

export const safeStorage = {
  getItem(key) {
    const ls = getSafeLocalStorage();
    if (!ls) return null;
    try { return ls.getItem(key); } catch { return null; }
  },
  setItem(key, val) {
    const ls = getSafeLocalStorage();
    if (!ls) return;
    try { ls.setItem(key, val); } catch {}
  },
  removeItem(key) {
    const ls = getSafeLocalStorage();
    if (!ls) return;
    try { ls.removeItem(key); } catch {}
  }
};
